import React from 'react';
import { Button, makeStyles, mergeClasses, shorthands } from '@fluentui/react-components';
import { ReactComponent as ToolkitIcon } from '../../../assets/toolkit/toolkit-icon.svg';
import { customColors } from '../../../styles';

// icon wrapper and svg selectors to apply hover and active states to the svg icon within the button. necessary to change the svg color on hover and active states. the svgs themselves need to have fill set to currentColor for this to work, which is done in the svg files.

const iconWrapper = '& > span';
const iconSvg = '& > span > svg';

const useStyles = makeStyles({
    button: {
        height: '42px',
        width: '42px',
        maxWidth: '42px',
        minWidth: '42px',
        ...shorthands.border('1px', 'solid', customColors.protivitiDarkBlue),
        ...shorthands.borderRadius('5px'),
        marginRight: '4px',
        transition: 'all 0.3s ease',

        [iconWrapper]: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },

        [iconSvg]: {
            color: customColors.protivitiDarkBlue,
            transition: 'all 0.3s ease',
        },

        '&:hover': {
            backgroundColor: customColors.protivitiDarkBlue,

            [iconSvg]: {
                color: customColors.white,
            },
        },

        '&:active': {
            backgroundColor: customColors.protivitiOrange,
            transition: 'all 0s',

            [iconSvg]: {
                color: customColors.white,
            },
        },
    },
    buttonActive: {
        backgroundColor: customColors.protivitiDarkBlue,

        [iconSvg]: {
            color: customColors.white,
        },

        '&:hover': {
            backgroundColor: customColors.summarizeButtonHover,
        },
    },
});

interface ToolkitProps {
    isOpen: boolean;
    onToggle: () => void;
}

const ToolkitButton: React.FC<ToolkitProps> = ({ isOpen, onToggle }) => {
    const styles = useStyles();

    return (
        <Button
            className={mergeClasses(styles.button, isOpen && styles.buttonActive)}
            appearance="transparent"
            icon={<ToolkitIcon />}
            aria-label={isOpen ? 'Close toolkit' : 'Open toolkit'}
            aria-pressed={isOpen}
            onClick={onToggle}
        />
    );
};

export default ToolkitButton;
